import React from 'react';

import styled from 'styled-components';

export default function Article({
  title,
  publisher,
  pressImage,
  pubdate,
  desc,
  link,
}) {
  return (
    <StyledArticle>
      <a href={link} target="_blank" rel="noreferrer">
        <StyledImageContainer pressImage={pressImage} />
        <StyledPublishInfoContainer>
          <StyledPublisher>{publisher}</StyledPublisher>
          <StyledPubdate>{pubdate}</StyledPubdate>
        </StyledPublishInfoContainer>
        <StyledTitle>{title}</StyledTitle>
        <StyledDesc>{desc}</StyledDesc>
      </a>
    </StyledArticle>
  );
}

const StyledArticle = styled.li`
  max-width: 23%;
  position: relative;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey4};
  transition: transform 0.3s;

  div {
    line-height: 1.6;
  }

  ${({ theme }) => theme.mobile`
  max-width: 49%;
  `}

  &:hover {
    transform: translateY(-3px);
  }
`;

const StyledImageContainer = styled.div`
  width: 100%;
  height: 300px;
  background-image: ${({ pressImage }) => `url(${pressImage})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  ${({ theme }) => theme.mobile`
    height: 200px;
  `}
`;

const StyledPublishInfoContainer = styled.div`
  margin: 8px 0;
  ${({ theme }) => theme.flex('row', 'space-between', 'flex-start')}
`;

const StyledPublisher = styled.div`
  color: ${({ theme }) => theme.colors.grey2};
  font-size: ${({ theme }) => theme.pixelToRem(11)};
  font-weight: 700;
`;

const StyledPubdate = styled.div`
  font-size: ${({ theme }) => theme.pixelToRem(11)};
  color: ${({ theme }) => theme.colors.grey3};
`;

const StyledTitle = styled.div`
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.pixelToRem(18)};
  font-weight: 700;

  ${({ theme }) => theme.multiLines(2)}
`;

const StyledDesc = styled.p`
  color: ${({ theme }) => theme.colors.grey2};
  font-size: ${({ theme }) => theme.pixelToRem(16)};
  line-height: 1.5;

  ${({ theme }) => theme.multiLines()}
`;
